import { reportEventLog } from './dto/reportEventLog';
import http from '../httpService';

class ReportEventLogService {
  public async getReportEventLogs(): Promise<reportEventLog[]> {
    let result = await http.get('/api/services/app/ReportEventLog/GetReportEventLogs');

    return result.data.result;
  }
}

export default new ReportEventLogService();
